export const APPROVAL_GROUP_ABANDON_EMPTY_TITLE =
  'Leave without adding a member?';

export const APPROVAL_GROUP_ABANDON_EMPTY_MESSAGE =
  'Leaving without adding a user to the Approvals Group will turn the Approvals Group off.';

export const APPROVAL_GROUP_ABANDON_EMPTY_CONTINUE = 'Continue';

export const APPROVAL_GROUP_ABANDON_EMPTY_CANCEL = 'Stay';
